import { render, staticRenderFns } from "./DetailModal.vue?vue&type=template&id=ee9234a2&scoped=true&"
import script from "./DetailModal.vue?vue&type=script&lang=js&"
export * from "./DetailModal.vue?vue&type=script&lang=js&"
import style0 from "./DetailModal.vue?vue&type=style&index=0&id=ee9234a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9234a2",
  null
  
)

export default component.exports